module.exports = __webpack_public_path__ + "img/benadryl_allergy_ultratabs.000e766b.jpg";